/**
 * ChangeAnalysisEmpty — empty-state copy for the importance list (T4).
 *
 * The GET endpoint can't tell "never analyzed" from "analyzed, nothing
 * classified", so the caller passes `hasAnalyzed` (derived from the summary's
 * `generatedAt`, the cross-session truth) to pick the right message. Viewer (no
 * run capability) gets a read-only prompt.
 */
import * as React from 'react';

export function ChangeAnalysisEmpty({
  canRun,
  running,
  hasAnalyzed,
}: {
  canRun: boolean;
  running: boolean;
  hasAnalyzed: boolean;
}): React.JSX.Element {
  let title: string;
  let body: string;

  if (running) {
    title = '正在分析…';
    body = '逐批判定每处变更的重要度并归纳修订摘要，变更较多时可能需要一些时间。';
  } else if (hasAnalyzed) {
    title = '未发现可分类的变更';
    body = '本比对没有可供重要度分类的实质变更，或上次分析全部降级。';
  } else if (canRun) {
    title = '尚未发起变更分析';
    body = '点击上方「发起变更分析」，对本比对的每处变更判定实质性 / 措辞级重要度，并生成修订摘要。';
  } else {
    title = '尚未分析';
    body = '本比对还没有变更分析结论。需要律师或审核员先发起分析。';
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-ink-200 bg-ink-0 px-6 py-12 text-center">
      <p className="text-sm font-semibold text-ink-700">{title}</p>
      <p className="max-w-md text-xs leading-relaxed text-ink-500">{body}</p>
    </div>
  );
}

export default ChangeAnalysisEmpty;
